import React, { useState } from "react";
import { TableRow, TableCell } from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import {
  ModalDefaultError,
  ModalDeleteConfirm,
  TableAction,
  TableWrapper,
  TableCellDefault,
} from "App/Component/ui";

import { useDatatables, useFetch } from "App/hooks";
import {
  ModalForm,
  headCells,
  deleteKasById,
  RESET_STATE_KAS,
  urlGet,
} from "./helpers";
import { TYPE_INSTANCE3 } from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
  formatNumber,
  isNull,
} from "App/utils/helpers";
import { FilterColumns, PrepareDataExport } from "../helpers";

export default function Kas() {
  const [showModal, setShowModal] = useState(false);
  const [showModalDefaultError, setShowModalDefaultError] = useState(false);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [rows, setRows] = useFetch(TYPE_INSTANCE3, urlGet, "body");

  const [formData, setFormData] = useState(RESET_STATE_KAS);

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "nama",
    orderByRow: ["nama"],
  });

  function clickAdd() {
    setFormData(RESET_STATE_KAS);
    setShowModal(!showModal);
  }

  function clickUpdate(row) {
    setFormData({
      id: row?.id,
      nama: row?.nama,
      id_coa: row?.id_coa,
      nama_coa: isNull(row?.nama_coa) ? "Pilih COA" : row?.nama_coa,
      jumlah: row?.jumlah,
      no_rek: row?.no_rek,
      no_hp: row?.no_hp,
      jumlah2: formatNumber(row?.jumlah),
      telepon: row.telepon,
      no_contact_person: row.no_contact_person,
      status: row.status,
      remark: row.remark,
      is_bayar_saldo: row.is_bayar_saldo,
      is_penjualan: row.is_penjualan,
      is_bayar_tagihan: row.is_bayar_tagihan,
    });

    setShowModal(true);
  }

  function clickDelete(row) {
    setFormData({
      ...formData,
      id: row?.id,
    });
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  async function setNewData() {
    const res = await fetchData(TYPE_INSTANCE3, urlGet);
    setRows(res);
  }

  async function deleteList() {
    const res = await deleteKasById(formData.id);

    if (res.state) {
      defaultToastSuccess(res.message);
      await setNewData();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  const prepareHeaders = {
    nama: "nama",
    jumlah: "jumlah",
    no_rek: "no_rek",
    no_hp: "no_hp",
    createdAt: "inserted_time:date",
    createdName: "inserted_by",
    updatedAt: "updated_time:date",
    updatedName: "updated_by",
  };
  const dataExport = PrepareDataExport(data, prepareHeaders);
  const headerExport = FilterColumns(dataExport);

  return (
    <>
      {showModal && (
        <ModalForm
          setNewData={setNewData}
          setShowModal={() => setShowModal(false)}
          formData={formData}
          setFormData={setFormData}
        />
      )}

      {showModalDefaultError && (
        <ModalDefaultError
          setShowModalDefaultError={() => setShowModalDefaultError(true)}
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <TableWrapper
        title="Daftar Kas"
        setQ={setQ}
        clickAddButton={() => clickAdd()}
        withExportButton={true}
        allData={dataExport}
        headers={headerExport}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        withPadding={true}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center">
                  {index + 1}
                </TableCell>

                <TableCell component="th" scope="row" padding="none">
                  <TableAction
                    clickDelete={() => clickDelete(row)}
                    clickUpdate={() => clickUpdate(row)}
                  />
                </TableCell>

                <TableCell align="left">{row?.nama}</TableCell>
                <TableCell align="left">{row?.nama_coa}</TableCell>
                <TableCell align="left">{formatNumber(row?.jumlah)}</TableCell>
                <TableCell align="left">{row?.no_rek}</TableCell>
                <TableCell align="left">{row?.no_hp}</TableCell>
                <TableCell align="left">{row?.is_bayar_saldo ? "YA" : "TIDAK"}</TableCell>
                <TableCell align="left">{row?.is_penjualan ? "YA" : "TIDAK"}</TableCell>
                <TableCell align="left">{row?.is_bayar_tagihan ? "YA" : "TIDAK"}</TableCell>

                <TableCellDefault row={row} />
              </TableRow>
            );
          })}
      </TableWrapper>
    </>
  );
}
